import styled, { css } from 'styled-components';

export const UnitSelectorWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;

  background-color: white;
  border: 1px solid rgb(209, 209, 213);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 8px 0px;
  max-width: 300px;
  width: 100%;
  z-index: 10;
  max-height: 400px;
  overflow-y: auto;
`;

export const DropdownTrigger = styled.button`
  background: none;
  border: none;
  color: rgb(0, 122, 112);
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  padding: 0;
  margin-top: 4px;

  &:hover {
    text-decoration: none;
  }
`;
export const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgb(227, 227, 230);
  margin: 0;
`;

export const GroupHeader = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(245, 245, 247);
  border-bottom: 1px solid rgb(227, 227, 230);
`;

export const GroupTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: rgb(45, 45, 48);
`;

export const GroupCount = styled.div`
  font-size: 14px;
  color: rgb(118, 118, 123);
`;

export const UnitItemTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 20px;
  width: 100%;
`;

export const UnitItem = styled.div<{ isEmptyInfo?: boolean }>`
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  min-height: 65px;

  ${({ isEmptyInfo }) =>
    isEmptyInfo
      ? css`
          justify-content: center; /* Center UnitItemTopRow when UnitInfo is not displayed */
        `
      : css`
          gap: 4px;
        `}
  &:hover {
    background-color: rgb(245, 245, 247);
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgb(227, 227, 230);
  }
`;

export const UnitName = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: rgb(45, 45, 48);
`;

export const UnitPrice = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: rgb(45, 45, 48);
`;

export const UnitInfo = styled.div<{ isEmpty?: boolean }>`
  font-size: 12px;
  color: rgb(118, 118, 123);
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      display: none;
    `}
`;
